import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ClientActions from '../../actions/clientActions';
import * as SiteActions from '../../actions/siteActions';
import * as UiActions from '../../actions/uiActions';

class DeleteEquipmentEntityModal extends Component {
    handleDelete = async () => {
        const {
            deleteAreaEquipment,
            deleteSystemEquipment,
            selectedEquipment,
            selectedNode,
            selectedSite
        } = this.props;

        let isDeleted;

        switch (selectedNode.type) {
            case 'areaItem':
                if (!this.props.isLoading) {
                    this.props.toggleLoading(true);
                    isDeleted = await deleteAreaEquipment(selectedNode.id, selectedEquipment.id, selectedSite.id);
                }

                if (isDeleted) this.handleClose();
                break;
            case 'systemItem':
                if (!this.props.isLoading) {
                    this.props.toggleLoading(true);
                    isDeleted = await deleteSystemEquipment(selectedNode.id, selectedEquipment.id, selectedSite.id);
                }

                if (isDeleted) this.handleClose();
                break;
            default:
                break;
        }

    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    getContent = () => {
        const { selectedEquipment, selectedNode } = this.props;

        switch (selectedNode.type) {
            case 'areaItem':
                return `Are you sure you want to delete Equipment: ${selectedEquipment.name} from Area: ${selectedNode.name}?`;
            case 'systemItem':
                return `Are you sure you want to disassociate Equipment: ${selectedEquipment.name} from System: ${selectedNode.name}?`;
            default:
                return `Are you sure you want to delete ${selectedEquipment.name} from Entity?`;
        }
    }

    getTitle = () => {
        const { selectedNode } = this.props;

        switch (selectedNode.type) {
            case 'areaItem':
                return 'Delete Equipment from Area';
            case 'systemItem':
                return 'Disassociate Equipment from System';
            default:
                return 'Delete Equipment from Entity';
        }
    }

    render() {
        const {
            errors,
            isLoading,
            open
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={this.getTitle()}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                confirmText="Delete"
            >
                <p>
                    {this.getContent()}
                </p>
            </EsmsDialog>
        );
    }
}

DeleteEquipmentEntityModal.defaultProps = {
    selectedNode:      {},
    selectedEquipment: {}
};

DeleteEquipmentEntityModal.propTypes = {
    companyInfo:       object,
    close:             func.isRequired,
    open:              bool.isRequired,
    selectedNode:      object,
    selectedEquipment: object
};

const mapStateToProps = state => {
    return {
        errors:            state.messages.errors,
        isLoading:         state.ui.isLoading,
        selectedClient:    state.client.selectedClient,
        selectedNode:      state.architect.selectedNode,
        selectedEquipment: state.architect.selectedEquipment,
        selectedSite:      state.site.selectedSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...ClientActions,
    ...SiteActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEquipmentEntityModal);
